const CardSkeleton: React.FC = () => {
	return (
		<div className="w-full animate-pulse space-y-4">
			<div className="flex w-full justify-between">
				<div className="w-4/6 space-y-4">
					<div className="bg-fill-press mt-4 h-4 w-5/6 rounded" />
					<div className="bg-fill-press h-4 w-3/4 rounded" />
					<div className="bg-fill-press h-4 w-5/6 rounded" />
				</div>
				<div className="rounded-small bg-fill-press aspect-square h-16 w-16 object-cover md:h-[100px] md:w-[100px] md:rounded xl:h-40 xl:w-40" />
			</div>
		</div>
	);
};

export const LoadingSkeleton: React.FC = () => {
	return (
		<div className="mt-[110px] flex flex-col gap-4 md:mt-4" data-testid="loading-skeleton">
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
		</div>
	);
};
